import { useCallback } from "react";

interface useChangeInterface {
  setFormError?: (e: any) => any;
  setState: (e: any) => any;
}

export const useChange = ({ setFormError, setState }: useChangeInterface) => {
  const onIonChange = useCallback(
    (event: any) => {
      const { detail, target } = event;
      let { value, name } = detail;
      if (target) {
        if (target.name) {
          name = target.name;
        }
      }

      if (setFormError !== undefined) {
        setFormError((prevState: any) => ({
          ...prevState,
          [name]: !(value !== ""),
        }));
      }

      setState((prevState: any) => {
        if (prevState.form !== undefined) {
          return {
            ...prevState,
            form: {
              ...prevState.form,
              [name]: value,
            },
          };
        }
        return {
          ...prevState,
          [name]: value,
        };
      });
    },
    [setState, setFormError]
  );

  return { onIonChange };
};

export default useChange;
